import Login from "./pages/login/Login.jsx";
import Register from "./pages/register/Register.jsx";
import { createBrowserRouter, Navigate, Outlet, RouterProvider, } from "react-router-dom";
import Navbar from "./components/navbar/Navbar.jsx";
import LeftBar from "./components/leftBar/LeftBar.jsx";
import RightBar from "./components/rightBar/RightBar.jsx";
import Profile from "./pages/profile/Profile.jsx";
import Home from "./pages/home/Home.jsx";
import Messenger from "./pages/messenger/Messenger.jsx";
import "./style.scss";
import { DarkModeContext } from "./context/darkModeContext.js";
import { useContext } from "react";
import { AuthContext } from "./context/authContext.js";
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query';

function App() {
  const {currentUser} = useContext(AuthContext);
  const { darkMode } = useContext(DarkModeContext);
  const queryClient = new QueryClient()

  const Layout = () => {
    return (
      <QueryClientProvider client={queryClient}>
        <div className={`theme-${darkMode ? "dark" : "light"}`}>
          <Navbar />
          <div className="layout-container" style={{ display: "flex", height: "calc(100vh - 50px)" }}>
            <LeftBar />
            <div className="content-area" style={{ flex: 6, overflow: "auto" }}>
              <Outlet />
            </div>
            <RightBar />
          </div>
        </div>
      </QueryClientProvider>
    );
  };

  const MssngrLayout = () => {
    return (
    <QueryClientProvider client={queryClient}>
      <div className={`theme-${darkMode ? "dark" : "light"}`}>
        <Navbar />
        <Messenger />
      </div>
    </QueryClientProvider>
    )
  };

  const ProtectedRoute = ({ children }) => {
    if (!currentUser) {
      return <Navigate to="/login" />;
    }
    return children;
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/profile/:id",
          element: <Profile />,
        },
      ],
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/register",
      element: <Register />,
    },
    {
      path: "/messenger",
      element: (
        <ProtectedRoute>
          <MssngrLayout />
        </ProtectedRoute>
      ),
    },
  ]);

  return (
    <RouterProvider router={router} />
  );
}

export default App;
